import React from 'react'
import { Controller, FieldValues, UseFormReturn, RegisterOptions } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import InputField from '../../../../components/common/inputs/InputField'

interface Props {
  formControl: UseFormReturn<FieldValues>
  name: string
  label: string
  infoTip?: string
  rules?: RegisterOptions
  disabled?: boolean
  defaultValue?: string
  currencySymbol: string
  currencyUnit: string
  allowNegative?: boolean
  decimalScale?: number
  endAdornment?: string
}

const PriceField: React.FC<Props> = ({
  formControl,
  name,
  label,
  infoTip,
  rules,
  disabled,
  defaultValue,
  currencySymbol,
  currencyUnit,
  endAdornment,
  allowNegative = false,
  decimalScale = 2,
}) => {
  return (
    <Controller
      name={name}
      control={formControl.control}
      rules={rules}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, ref, name, value },
        fieldState: { error }
      }) => {
        return <NumberFormat
          value={value}
          onValueChange={(values) => {
            onChange(values.value)
          }}
          onBlur={onBlur}
          name={name}
          errorMessage={error?.message}
          thousandSeparator
          decimalScale={decimalScale}
          fixedDecimalScale={true}
          allowNegative={allowNegative}
          customInput={InputField}
          id={name}
          startAdornment={currencySymbol}
          endAdornment={endAdornment || currencyUnit}
          getInputRef={ref}
          label={label}
          infoTip={infoTip}
          disabled={disabled}
          isNumericString={true}
        />
      }}
    />
  )
}

export default PriceField
